import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '@lockton-apps/shared/interfaces';
import { compact, join } from 'lodash';

@Pipe({
  name: 'address',
  standalone: true,
})
export class AddressPipe implements PipeTransform {
  transform(value: Partial<Address>): string {
    if (!value) {
      return '';
    }
    return join(
      compact([value.street, value.cityTown, value.country, value.postcode]),
      ', '
    );
  }
}
